import React, { FC } from "react";
import { createPortal } from "react-dom";
import Icon from "components/Elements/Icon/Icon";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer";
import { useContent } from "contexts/contentContext/contentContext";
import useMediaQueries from "hooks/useMediaQueries";

/**
 *
 * Bottom popup for inbox
 *
 */

type MenuContainerT = {
  headerKey?: string;
  showSidebar?: boolean;
  setShowSidebar: (value: boolean) => void;
  children: JSX.Element;
};

const MenuContainer: FC<MenuContainerT> = (props) => {
  const { headerKey, setShowSidebar, children } = props;
  const { getTextByKey } = useContent();
  return createPortal(
    <div className="inbox-mobile-mail-menu inbox-mobile-mail-menu-container">
      {headerKey ? (
        <div className="menu-header">
          {getTextByKey(headerKey)}
          <Icon
            name="x"
            gray
            onClick={() => {
              setShowSidebar(false);
            }}
          />
        </div>
      ) : (
        <div className="menu-no-header">
          <Icon
            name="x"
            gray
            onClick={() => {
              setShowSidebar(false);
            }}
          />
        </div>
      )}
      <div className="menu-content">{children}</div>
    </div>,
    document.getElementById("inbox-container")!
  );
};

const MobileBottomMenuContainer: FC<MenuContainerT> = ({
  showSidebar,
  setShowSidebar,
  headerKey,
  children,
}) => {
  const { mobileCondition } = useMediaQueries();

  return mobileCondition ? (
    <AnimationContainer
      animationOn={showSidebar}
      animationClassName="side-bar-animation"
    >
      <MenuContainer
        setShowSidebar={setShowSidebar}
        headerKey={headerKey}
        children={children}
      />
    </AnimationContainer>
  ) : (
    <></>
  );
};

export default MobileBottomMenuContainer;
